import * as Yup from 'yup';
import { Proposal, Address, City, State, BankAccount, Bank } from 'generated/graphql';

Yup.setLocale({
    mixed: {
        required: 'Este campo é obrigatório',
    }
});

export const proposalSchema = (
    loanAmountMin: number,
    loanAmountMax: number,
    loanTenureMin: number,
    loanTenureMax: number
) => Yup.object().shape<Proposal>({
    date: Yup
        .date()
        .required(),
    amount: Yup
        .number()
        .required()
        .test('', '', (amount: number) => (
            amount >= loanAmountMin && amount <= loanAmountMax
        )),
    tenure: Yup
        .number()
        .test('', '', (tenure: number) => (
            tenure >= loanTenureMin && tenure <= loanTenureMax
        )),
    paymentDay: Yup
        .date()
        .required(),
});

export const addressSchema = Yup.object().shape<Address>({
    zipCode: Yup
        .string()
        .required(),
    street: Yup
        .string()
        .required(),
    neighbourhood: Yup
        .string()
        .required(),
    number: Yup
        .string()
        .required(),
    city: Yup
        .object()
        .required()
        .shape<City>({
            id: Yup
                .string()
                .required(),
            state: Yup
                .object()
                .shape<State>({
                    id: Yup
                        .string()
                        .required()
                })
        }),
});

export const bankAccountSchema = Yup.object().shape<BankAccount>({
    agency: Yup
        .string()
        .required(),
    account: Yup
        .string()
        .required(),
    bank: Yup
        .object()
        .required()
        .shape<Bank>({
            id: Yup
                .string()
                .required()
        }),
});

export const addressLegacySchema = Yup.object().shape({
    zipCode: Yup
        .string()
        .required(),
    street: Yup
        .string()
        .required(),
    neighbourhood: Yup
        .string()
        .required(),
    number: Yup
        .string()
        .required(),
    city: Yup
        .string()
        .required(),
    state:Yup
        .string()
        .required()
});
